import Clarity from '@microsoft/clarity'

import { logger } from '@/lib/logger'

import type {
  AnalyticsProvider,
  EventProperties,
  UserProperties,
} from '../types'

export class ClarityProvider implements AnalyticsProvider {
  name = 'clarity'

  track(eventName: string, _properties?: EventProperties): void {
    try {
      Clarity.event(eventName)
    } catch (error) {
      logger.error('Clarity track failed', { eventName, error })
    }
  }

  identify(userId: string): void {
    try {
      Clarity.identify(userId)
    } catch (error) {
      logger.error('Clarity identify failed', { userId, error })
    }
  }

  alias(newId: string, _previousId?: string): void {
    try {
      Clarity.identify(newId)
    } catch (error) {
      logger.error('Clarity alias failed', { newId, error })
    }
  }

  setUserProperties(properties: UserProperties): void {
    try {
      for (const [key, value] of Object.entries(properties)) {
        if (value === null || value === undefined) continue
        Clarity.setTag(key, String(value))
      }
    } catch (error) {
      logger.error('Clarity setUserProperties failed', { error })
    }
  }

  reset(): void {
    // Clarity SDK does not expose a reset API.
  }
}
